
/**  USER TYPES  */
export const CLEAR_CURRENT_PROFILE = "CLEAR_CURRENT_PROFILE";
export const PROFILE_LOADING = "PROFILE_LOADING";
export const GET_PROFILE = "GET_PROFILE";
export const CURRENT_PERMISSION = "CURRENT_PERMISSION";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
// CREATE_PROFILE dropped in SCRUM-1024: it was single-reducer, so the save now
// writes via createProfile.fulfilled in profileSlice.js.
